export default {
  BASE_URL: '',
  api: [
    {
      name: 'login',
      method: 'POST',
      desc: '登录接口',
      path: '/crmMember/login',
      mock: false,
      params: {
        loginName: 'admin',
        password: 'admin'
      }
    },
    {
      name: 'getCurrentUser',
      method: 'GET',
      desc: '获取当前用户',
      path: 'sysUser/'
    },
    {
      name: 'tenderType',
      method: 'GET',
      desc: '获取招投标类型（其实是招投标一级类目）',
      path: '/category/parentCategory?bizId=1&parentId=0&all=false'
    },
    {
      name: 'tenderCategories',
      method: 'GET',
      desc: '获取招投标类目（其实是招投标二级类目）',
      path: '/category/childrenCategory?bizId=1&noPage=true'
    },
    {
      name: 'getAuthUrl',
      method: 'GET',
      desc: '获取授权地址',
      path: '//crmMember/authorizeUrl'
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '解绑微信',
      path: '//crmMember/delete'
    },
    {
      name: 'scan',
      method: 'GET',
      desc: '获取微信签名',
      path: '//crmMember/scan'
    },
    {
      name: 'getBanners',
      method: 'GET',
      desc: '获取banner',
      path: '/content/ad/adListForClient',
      append: true // 后跟banner位置
    },
    {
      name: 'userProtocol',
      method: 'GET',
      desc: '获取用户协议',
      path: '/crmMember/regisAgreement'
    },
    {
      name: 'getProductCategory',
      method: 'GET',
      desc: '获取商品分类',
      path: '/category/mobile/productCategory'
    },
    {
      name: 'userInfo',
      method: 'GET',
      desc: '获取个人信息',
      path: '//crmMember/userInfo'
    },
    {
      name: 'saveUserInfo',
      method: 'POST',
      desc: '保存用户信息',
      path: '//crmMember/saveUserInfo'
    },
    {
      name: 'updatePwd',
      method: 'PUT',
      desc: '修改密码',
      path: '/crmMember/updatePwd',
      mock: false,
      params: {}
    },
    {
      name: 'getMessageList',
      method: 'GET',
      desc: '获取消息列表',
      path: '/crm/message/getMessageList',
      mock: false,
      params: {}
    },
    {
      name: 'updateIsRend',
      path: '/crm/message/updateIsRendById',
      mock: false,
      append: true,
      method: 'PUT',
      desc: '修改消息为已读'
    },
    { // 会员消息接口
      name: 'getNewMessageCount',
      path: '/crm/message/getMessageTypeCountByReceiveId',
      mock: false,
      method: 'GET',
      desc: '获得新消息条数'
    },
    {
      name: 'logout',
      method: 'POST',
      desc: '注销',
      path: '/crmMember/logout'
    },
    {
      name: 'getCatasByParentId',
      method: 'GET',
      desc: '获取商品分类2',
      path: '/category/getCatasByParentId'
    },
    {
      name: 'getCurrentTime',
      method: 'GET',
      desc: '获取系统时间',
      path: '/pub/sys/getCurrentTime'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/common.js